export default __webpack_public_path__ + "static/img_logo_ichi_black-1c38d8d8e04542b1421ef1a1b2169f57.svg";